import React from 'react';

const Login = () => {
  return (
    <div className='login'>
      <h1>Login</h1>
      <p>Usuario:
        Clave:
      </p>
    </div>
  );
};

export default Login;